import React, { useEffect, useState } from "react";
import { scaleLinear } from "d3-scale";
import {
  ComposableMap,
  Geographies,
  Geography,
  Sphere,
  Graticule,
} from "react-simple-maps";
// import { geoUrl } from "./features";
import { store } from "../../../redux/store";
import GeographyComponent from "./GeographyComponent";
import { iso2ToName } from "./Iso2ToName";
import {iso2ToIso3Map } from "./Country.tsx"

const SimpleMap = () => {
  const report = store.getState()?.report?.map;
  const data = report?.users_by_country;
  const geoUrl =
    "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";
  const maxValue = Math.max(...data.map((d) => Number(d.Count)));

  const colorScale = scaleLinear()
    .domain([0, maxValue])
    .range(["#DFC2D2", "#651c66"]);
  const normalize = (str) =>
    str
      ?.toLowerCase()
      .replace(/[^a-z]+/g, "")
      .trim();

  return (
    <>

      <ComposableMap
        projectionConfig={{
          rotate: [-10, 0, 0],
          scale: 147,
        }}
        style={{ marginTop: "-70px", marginBottom: "-70px" }}
      >
        <Sphere stroke="#E4E5E6" strokeWidth={0.5} />
        <Graticule stroke="#E4E5E6" strokeWidth={0.5} />

        {data?.length > 0 && (
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo, index) => {
                const countryName = geo.properties.name;

                const d = data.find((s) => {
                  const properName = iso2ToName[s.Country];
                  return normalize(properName) === normalize(countryName);
                });

                const count = Number(d?.Count ?? d?.count ?? 0);

                return (
                  <GeographyComponent
                    key={index}
                    data={d}
                    geo={geo}
                    fill={d ? colorScale(count) : "#edd8e1"}
                  />
                );
              })
            }
          </Geographies>
        )}
      </ComposableMap>
    </>
  );
};

export default SimpleMap;
